import { Typography } from "@mui/material";
import React from "react";

const ErrorText = ({ text }) => {
  return <Typography color="error" sx={{ fontSize: "12px" }}>{text}</Typography>;
};

export default ErrorText;
